module.exports = __webpack_public_path__ + "img/public/SiteIcons/currencyIconTwo.svg?77f2218c";